// extracted by mini-css-extract-plugin
module.exports = {"list":"_3Z6fB","label":"rDuvw","link":"_3IZG0","span":"_2gKAw","icon":"mDJKB","item":"_1hSZ3"};